import {useEffect, useState} from "react";

export const DelayedEffectHook = (callback: () => void, depends: any[] = [], timeout: number = 1000) => {
	const [value, setValue] = useState<any>(null);
	useEffect(() => {
		const sTimeout = setTimeout(callback, timeout);
		setValue(sTimeout);
		return () => clearTimeout(sTimeout);
	}, depends);

	return {
		clear: () => {
			if (!value) return;

			clearTimeout(value);
			setValue(null);
		}
	}
}

export const DelayedHookState = (timeout: number = 1000, destroyOnUnMount = true) => {
	const [value, setValue] = useState<any>(null);

	useEffect(() => {
		return () => {
			if (!value) return;

			if (destroyOnUnMount)
			{
				clearTimeout(value);

				console.debug('DelayedHookState.call.clear', value, timeout);
			}
		};
	}, []);

	return {
		call: (callback: () => void) => {
			if (value)
			{
				clearTimeout(value);
			}

			const sTimeout = setTimeout(() => {
				if (value) setValue(null);

				console.debug('DelayedHookState.call.callback', sTimeout, timeout);

				callback();
			}, timeout);

			console.debug('DelayedHookState.call', sTimeout, timeout);

			setValue(sTimeout);

			return () => {
				console.debug('DelayedHookState.call.clear', sTimeout);
				clearTimeout(sTimeout);
			}
		},
		clear: () => {
			if (!value) return;

			clearTimeout(value);

			console.debug('DelayedHookState.call.clear', value);
			setValue(null);
		}
	}
}